"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.to-string");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDPlanHeaderComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDPlanHeaderComponent, _Mixins);

  var _super = _createSuper(LMDPlanHeaderComponent);

  function LMDPlanHeaderComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDPlanHeaderComponent);
    _this = _super.apply(this, arguments);
    _this.oldPlanDate = null;
    _this.selectedPlanId = 'newPlanId';
    _this.isShowSendToWarehouseModal = false;
    _this.selectedWarehousePlanId = [];
    return _this;
  }

  (0, _createClass2.default)(LMDPlanHeaderComponent, [{
    key: "on$PlanDateChanges",
    value: function on$PlanDateChanges(newVal, oldVal) {
      this.oldPlanDate = oldVal;
      this.selectedPlanId = 'newPlanId';
      this.$startDate = "".concat(newVal, " 00:00:00");
      this.$endDate = "".concat(newVal, " 23:59:59");
      this.$getOrderLocationLists({
        locationType: this.$locationType,
        startTime: this.$startDate,
        endTime: this.$endDate
      });
    }
  }, {
    key: "onSelectedTruckChanges",
    value: function onSelectedTruckChanges(newVal) {
      if (this.helper.isUndefined(newVal)) {
        this.selectedPlanId = 'newPlanId';
      } else {
        var truck = this.getTruckInPlan(this.$selectedTruck);

        if (this.helper.isUndefined(truck)) {
          this.selectedPlanId = 'newPlanId';
        } else {
          this.selectedPlanId = 'newPlanId';
        }
      }
    }
  }, {
    key: "isAssignToTruckDisabled",
    get: function get() {
      return this.$selectedOrders.length === 0 || this.$selectedTruck === null || this.selectedPlanId === null;
    }
  }, {
    key: "isAssignToWarehouseDisabled",
    get: function get() {
      return this.$anyChanges || !this.$plan.trucks || this.$plan.trucks.length === 0;
    }
  }, {
    key: "isAssignDriverDisabled",
    get: function get() {
      return this.$anyChanges || this.helper.get(this.$plan, 'trucks', []).length === 0;
    }
  }, {
    key: "isUnassignDriverDisabled",
    get: function get() {
      return this.$anyChanges || this.helper.get(this.$plan, 'trucks', []).length === 0;
    }
  }, {
    key: "getAssignTruckDisabledDetails",
    get: function get() {
      var reason = {
        reason1: false,
        reason2: false,
        reason3: false
      };

      if (this.selectedPlanId === null) {
        reason.reason1 = true;
      }

      if (this.$selectedOrders.length === 0) {
        reason.reason2 = true;
      }

      if (this.$selectedTruck === null) {
        reason.reason3 = true;
      }

      return reason;
    }
  }, {
    key: "getAssignWarehouseDisabledDetails",
    get: function get() {
      var reason = {
        reason1: false,
        reason2: false
      };

      if (this.$anyChanges) {
        reason.reason1 = true;
      }

      if (this.helper.get(this.$plan, 'trucks', []).length === 0) {
        reason.reason2 = true;
      }

      return reason;
    }
  }, {
    key: "getAssignTrucksDisabledDetails",
    get: function get() {
      var reason = {
        reason1: false,
        reason2: false
      };

      if (this.$anyChanges) {
        reason.reason1 = true;
      }

      if (this.helper.get(this.$plan, 'trucks', []).length === 0) {
        reason.reason2 = true;
      }

      return reason;
    }
  }, {
    key: "areRoutesInTruckMultiplePlanner",
    get: function get() {
      var isAllowEditOtherUserData = this.$userData.updateUserData || false;

      if (isAllowEditOtherUserData) {
        return false;
      }

      if (!this.$plan || !this.$plan.trucks || !this.currPlanTruck) {
        return false;
      }

      var uniqUsers = this.helper.uniq(this.currPlanTruck['routes'].map(function (r) {
        return r['user'];
      }));

      if (this.helper.isUndefined(uniqUsers[0])) {
        return false;
      }

      return uniqUsers.length > 1 ? true : uniqUsers[0] !== this.$userInformation.user.name;
    }
  }, {
    key: "areRoutesInTruckCompleted",
    get: function get() {
      if (!this.$plan || !this.$plan.trucks || !this.currPlanTruck) {
        return false;
      }

      return this.currPlanTruck['routes'].some(function (route) {
        if (route.status.toUpperCase() === 'COMPLETED') {
          return true;
        }
      });
    }
  }, {
    key: "isPlanIdRoutesSomeCompleted",
    get: function get() {
      var _this2 = this;

      if (this.selectedPlanId === 'newPlanId') {
        return this.areRoutesInTruckCompleted;
      }

      var bufferRoutes = this.routes.filter(function (r) {
        return r['planId'] === _this2.selectedPlanId;
      });

      if (this.helper.isUndefined(bufferRoutes) && !bufferRoutes.length) {
        return false;
      }

      return this.helper.some(bufferRoutes, function (i) {
        return i.status.toUpperCase() === 'COMPLETED';
      });
    }
  }, {
    key: "checkIfTruckHasRoutes",
    get: function get() {
      var _this3 = this;

      if (this.$selectedTruck) {
        var selectedOrderId = this.helper.get(this.helper.find(this.$plan.trucks, function (truck) {
          return truck['truckId'] === _this3.$selectedTruck;
        }), 'orderId', []);
        return selectedOrderId.length >= 1;
      } else {
        return false;
      }
    }
  }, {
    key: "warehouseTable",
    get: function get() {
      return this.helper.get(this.$refs, 'warehouseTable', null);
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "handlePlanDateChanges",
    value: function () {
      var _handlePlanDateChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.$anyChanges) {
                  _context2.next = 5;
                  break;
                }

                message = this.$i18n.t('planning.messages.unsavedChanges');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _this4.oldPlanDate = null;
                          _this4.$anyChanges = false;
                          _context.next = 4;
                          return _this4.refreshPlan();

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))).catch(function () {
                  _this4.$planDate = _this4.oldPlanDate;
                });

                _context2.next = 8;
                break;

              case 5:
                _context2.next = 7;
                return this.refreshPlan();

              case 7:
                this.enableAllTrucks();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handlePlanDateChanges() {
        return _handlePlanDateChanges.apply(this, arguments);
      }

      return handlePlanDateChanges;
    }()
  }, {
    key: "refreshPlan",
    value: function () {
      var _refreshPlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.$truckLoading = true;
                this.isManualAssignLoading = true;
                _context3.next = 4;
                return this.$resetPlan();

              case 4:
                _context3.next = 6;
                return this.$initPlan();

              case 6:
                if (!this.isAutoAssign) {
                  _context3.next = 14;
                  break;
                }

                if (!this.$selectedLocation) {
                  _context3.next = 11;
                  break;
                }

                this.logger.info('refreshPlan - Get Unassigned Orders');
                _context3.next = 11;
                return this.$getUnassignedOrders();

              case 11:
                this.disableInvalidTrucks();
                _context3.next = 17;
                break;

              case 14:
                this.logger.info('refreshPlan 2 - Get Unassigned Orders');
                _context3.next = 17;
                return this.$getUnassignedOrders();

              case 17:
                this.$truckLoading = false;
                this.isManualAssignLoading = false;

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refreshPlan() {
        return _refreshPlan.apply(this, arguments);
      }

      return refreshPlan;
    }()
  }, {
    key: "refreshBrowser",
    value: function refreshBrowser() {
      location.reload();
    }
  }, {
    key: "assignToTruck",
    value: function assignToTruck() {
      this.$emit('onManualAssignTruck', this.selectedPlanId);

      var p = _objectSpread(_objectSpread({}, this.$pagination), {}, {
        currentPage: 1
      });

      this.$setPagination(p);
      this.logger.info('assignToTruck - Set pagination', JSON.stringify(this.$pagination));
      this.selectedPlanId = 'newPlanId';
    }
  }, {
    key: "autoAssignToTruck",
    value: function autoAssignToTruck() {
      this.$emit('onAutoAssignTruck');
    }
  }, {
    key: "autoAssignAllToTruck",
    value: function autoAssignAllToTruck() {
      this.$emit('onAutoAssignAll');
    }
  }, {
    key: "confirmDeleteTruck",
    value: function () {
      var _confirmDeleteTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                message = this.$i18n.t('planning.messages.deleteRoutesTruckConfirmation');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then(function () {
                  var bool = _this5.isAutoAssign;

                  _this5.deleteRoutesInTruck({
                    isAutoAssign: bool,
                    planId: _this5.selectedPlanId === 'newPlanId' ? null : _this5.selectedPlanId
                  });
                }).catch(function (action) {});

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function confirmDeleteTruck() {
        return _confirmDeleteTruck.apply(this, arguments);
      }

      return confirmDeleteTruck;
    }()
  }, {
    key: "confirmDeletePlan",
    value: function () {
      var _confirmDeletePlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this6 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                message = this.$i18n.t('planning.messages.deletePlanConfirmation');

                _elementUi.MessageBox.prompt(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then(function (_ref2) {
                  var value = _ref2.value,
                      action = _ref2.action;

                  if (value !== _this6.$userInformation.user.name) {
                    var m = {
                      title: _this6.$t('planning.wrongUsername'),
                      duration: 30000
                    };

                    _elementUi.Notification.warning(m);

                    return;
                  }

                  var bool = _this6.isAutoAssign;

                  _this6.deletePlan({
                    isAutoAssign: bool
                  });
                }).catch(function (action) {});

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function confirmDeletePlan() {
        return _confirmDeletePlan.apply(this, arguments);
      }

      return confirmDeletePlan;
    }()
  }, {
    key: "confirmBatchUnassign",
    value: function () {
      var _confirmBatchUnassign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this7 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                message = this.$i18n.t('planning.messages.batchUnassignConfirmation');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then(function () {
                  _this7.unassignTrucksFromDriver();
                }).catch(function (action) {});

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function confirmBatchUnassign() {
        return _confirmBatchUnassign.apply(this, arguments);
      }

      return confirmBatchUnassign;
    }()
  }, {
    key: "handleSelectedTruckChanges",
    value: function handleSelectedTruckChanges(truckId) {
      // Socket for global trucks
      this.socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        truckId: truckId ? [truckId] : []
      });
    }
  }, {
    key: "sendToWarehouse",
    value: function () {
      var _sendToWarehouse = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var payload, message, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.isAutoAssignLoading = true;
                this.isManualAssignLoading = true;
                payload = {
                  code: this.$planDate,
                  userId: this.$userInformation.user.id,
                  userEmail: this.$userInformation.user.name,
                  type: 'send',
                  blockedTrucks: this.$userInformation['blockedTrucks'] || []
                };

                if (this.selectedWarehousePlanId.length) {
                  payload['planIds'] = this.selectedWarehousePlanId;
                }

                message = {
                  title: this.$i18n.t('planning.messages.sendToWarehouseFailed'),
                  duration: 5000
                };
                _context7.next = 7;
                return this.lastMileDeliveryAPI.sendToWarehouse({
                  userId: this.helper.get(this.$userInformation, 'user.id', null)
                }, payload);

              case 7:
                res = _context7.sent;

                if (!(!res || res.failed)) {
                  _context7.next = 11;
                  break;
                }

                _elementUi.Notification.error(message);

                return _context7.abrupt("return", false);

              case 11:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                this.hideSendToWarehouseModal();
                message['title'] = this.$i18n.t('planning.messages.sendToWarehouseSuccess');

                _elementUi.Notification.success(message);

                _context7.next = 18;
                return this.refreshPlan();

              case 18:
                return _context7.abrupt("return", true);

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function sendToWarehouse() {
        return _sendToWarehouse.apply(this, arguments);
      }

      return sendToWarehouse;
    }()
  }, {
    key: "assignTrucksToDriver",
    value: function () {
      var _assignTrucksToDriver = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this8 = this;

        var payload, toBeAssignedOrderIds, cantBeAssignedTrucks, message, assignDriverResponse, isAssignSuccessful, invalidOrders, _message, _message2, mappedOrderIds, plan, _message3;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                payload = [];
                toBeAssignedOrderIds = [];
                cantBeAssignedTrucks = [];
                this.$plan.trucks.forEach(function (truck) {
                  truck.routes.forEach(function (route) {
                    if (route.status === 'UNASSIGNED') {
                      toBeAssignedOrderIds.push({
                        orderId: route.orderId,
                        plateNumber: truck.plateNumber,
                        truckId: truck.truckId,
                        driverId: route.driverId
                      });
                    }
                  });
                });
                toBeAssignedOrderIds.forEach(function (i) {
                  i.orderId.forEach(function (j) {
                    var shipRef = _this8.helper.get(_this8.getOrdersField([j], 'shipmentReference'), '0', '');

                    var isExists = payload.find(function (k) {
                      return k.shipref === shipRef;
                    });
                    var hasDriver = !_this8.helper.isUndefined(i.driverId);

                    if (!isExists && hasDriver && shipRef) {
                      payload.push({
                        orderid: j,
                        shipref: shipRef,
                        drivercode: _this8.getCarPlateFromDriverId(i.driverId),
                        truckrecid: i.truckId
                      });
                    }

                    if (!hasDriver) {
                      cantBeAssignedTrucks.push(i.plateNumber);
                    }
                  });
                });
                cantBeAssignedTrucks = this.helper.uniq(cantBeAssignedTrucks);

                if (!(payload.length === 0)) {
                  _context8.next = 10;
                  break;
                }

                message = {
                  title: "".concat(this.$i18n.t('planning.messages.noAssignmentTruckHasNoDriver'), ": ").concat(cantBeAssignedTrucks.join(', ')),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context8.abrupt("return");

              case 10:
                _context8.next = 12;
                return this.assignDriver(payload);

              case 12:
                assignDriverResponse = _context8.sent;
                isAssignSuccessful = assignDriverResponse['isSuccess'];
                invalidOrders = assignDriverResponse['invalidOrders'];

                if (!isAssignSuccessful) {
                  _context8.next = 26;
                  break;
                }

                this.logger.info('Assign driver multiple trucks payload', payload);

                if (cantBeAssignedTrucks.length > 0) {
                  _message = {
                    title: "".concat(this.$i18n.t('planning.messages.assignOrderSuccess'), ". ").concat(this.$i18n.t('planning.messages.truckHasNoDriver'), ": ").concat(cantBeAssignedTrucks.join(', ')),
                    duration: 5000
                  };

                  _elementUi.Notification.success(_message);
                } else {
                  _message2 = {
                    title: this.$i18n.t('planning.messages.assignOrderSuccess'),
                    duration: 5000
                  };

                  _elementUi.Notification.success(_message2);
                }

                this.$isAssignedDriverChanges = false;
                mappedOrderIds = payload.map(function (i) {
                  return i.orderid;
                });
                plan = this.helper.cloneDeep(this.$plan);
                plan.trucks.forEach(function (truck) {
                  truck.routes.forEach(function (route) {
                    var intersections = _this8.helper.intersection(route.orderId, mappedOrderIds);

                    if (intersections.length > 0 && route.status !== 'COMPLETED') {
                      route.status = 'ASSIGNED';
                      truck.hasUpdate = true;
                    }
                  });
                });
                _context8.next = 24;
                return this.savePlan(plan, false, 'ASSIGNORDER', true, true);

              case 24:
                _context8.next = 28;
                break;

              case 26:
                _message3 = {
                  title: "".concat(this.$i18n.t('planning.messages.assigningFailedBecause'), " ").concat(invalidOrders, " ").concat(this.$i18n.t('planning.messages.cantBeAssigned')),
                  duration: 5000
                };

                _elementUi.Notification.error(_message3);

              case 28:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function assignTrucksToDriver() {
        return _assignTrucksToDriver.apply(this, arguments);
      }

      return assignTrucksToDriver;
    }()
  }, {
    key: "unassignTrucksFromDriver",
    value: function () {
      var _unassignTrucksFromDriver = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _this9 = this;

        var toBeUnassignedOrderIds, completedOrderIds, toBeUnassignedOrderShipRefs, payload, message, res, plan;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                toBeUnassignedOrderIds = [];
                completedOrderIds = [];
                this.$plan.trucks.forEach(function (truck) {
                  truck.routes.forEach(function (route) {
                    if (route.status === 'ASSIGNED') {
                      var _toBeUnassignedOrderI;

                      (_toBeUnassignedOrderI = toBeUnassignedOrderIds).push.apply(_toBeUnassignedOrderI, (0, _toConsumableArray2.default)(route.orderId));
                    }

                    if (route.status === 'COMPLETED') {
                      completedOrderIds.push.apply(completedOrderIds, (0, _toConsumableArray2.default)(route.orderId));
                    }
                  });
                });
                toBeUnassignedOrderIds = this.helper.difference(this.helper.uniq(toBeUnassignedOrderIds), this.helper.uniq(completedOrderIds));
                toBeUnassignedOrderShipRefs = this.getShipRefsFromOrderId(toBeUnassignedOrderIds);
                payload = [];
                this.helper.forEach(toBeUnassignedOrderShipRefs, function (order) {
                  payload.push({
                    shipref: order
                  });
                });
                message = {
                  title: this.$i18n.t('planning.messages.unassignFailed'),
                  duration: 5000
                };

                if (!(payload.length === 0)) {
                  _context9.next = 12;
                  break;
                }

                message['title'] = this.$i18n.t('planning.messages.noOrdersToUnassign');

                _elementUi.Notification.warning(message);

                return _context9.abrupt("return");

              case 12:
                _context9.next = 14;
                return this.cancelDriverAssignment(payload);

              case 14:
                res = _context9.sent;

                if (res) {
                  _context9.next = 18;
                  break;
                }

                _elementUi.Notification.warning(message);

                return _context9.abrupt("return");

              case 18:
                this.logger.info('Unassign orders from multiple trucks payload', payload);
                plan = this.helper.cloneDeep(this.$plan);
                plan.trucks.forEach(function (truck) {
                  truck.routes.forEach(function (route) {
                    var intersections = _this9.helper.intersection(route.orderId, toBeUnassignedOrderIds);

                    if (intersections.length > 0 && route.status === 'ASSIGNED') {
                      route.status = 'UNASSIGNED';
                      truck.hasUpdate = true;
                    }
                  });
                });
                _context9.next = 23;
                return this.savePlan(plan, false, 'UNASSIGNORDER', true, true);

              case 23:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function unassignTrucksFromDriver() {
        return _unassignTrucksFromDriver.apply(this, arguments);
      }

      return unassignTrucksFromDriver;
    }()
  }, {
    key: "showUploadCSVModal",
    value: function showUploadCSVModal() {
      this.$emit('showUploadCSVModal', true);
    } // duplicated

  }, {
    key: "enableTruck",
    value: function enableTruck(truckId) {
      if (truckId) {
        this.disableTruckList = this.disableTruckList.filter(function (i) {
          return i !== truckId.toString();
        });
      }

      localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
    }
  }, {
    key: "enableAllTrucks",
    value: function enableAllTrucks() {
      var _this10 = this;

      this.$trucks.forEach(function (truck) {
        return _this10.enableTruck(truck['id']);
      });
    }
  }, {
    key: "massagedPlanData",
    get: function get() {
      if (!this.$plan || !this.$plan.trucks) {
        return [];
      }

      var data = [];
      var blockedTruckIds = this.helper.get(this.$userInformation, 'blockedTrucks', []);
      this.$plan.trucks.forEach(function (t) {
        if (blockedTruckIds.includes(t.vehicleId)) {
          return;
        }

        t.planId.forEach(function (pId) {
          data.push({
            vehicleId: t.vehicleId,
            plateNumber: t.plateNumber,
            planId: pId,
            username: t.userEmail
          });
        });
      });
      return data;
    }
  }, {
    key: "onIsShowSendToWarehouseModalChange",
    value: function onIsShowSendToWarehouseModalChange(newVal, oldVal) {
      var _this11 = this;

      if (!newVal) {
        return;
      }

      if (this.massagedPlanData.length) {
        this.selectedWarehousePlanId = this.massagedPlanData.map(function (i) {
          return {
            vehicleId: i.vehicleId,
            planId: i.planId
          };
        });
      }

      this.$nextTick(function () {
        if (_this11.helper.isUndefined(_this11.warehouseTable)) {
          return;
        }

        _this11.massagedPlanData.forEach(function (row) {
          _this11.warehouseTable.toggleRowSelection(row);
        });
      });
    }
  }, {
    key: "selectWarehouseClick",
    value: function selectWarehouseClick($event, row) {
      this.selectedWarehousePlanId = this.helper.findIndex(this.selectedWarehousePlanId, function (i) {
        return i.planId === row.planId;
      }) === -1 ? [].concat((0, _toConsumableArray2.default)(this.selectedWarehousePlanId), [{
        vehicleId: row.vehicleId,
        planId: row.planId
      }]) : this.helper.filter(this.selectedWarehousePlanId, function (i) {
        return i.planId !== row.planId;
      });
    }
  }, {
    key: "selectWarehouseAll",
    value: function selectWarehouseAll($event) {
      if ($event.length > 0) {
        this.selectedWarehousePlanId = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(this.selectedWarehousePlanId), (0, _toConsumableArray2.default)($event.map(function (row) {
          return {
            vehicleId: row.vehicleId,
            planId: row.planId
          };
        }))), 'planId');
      } else {
        this.selectedWarehousePlanId = [];
      }
    }
  }, {
    key: "handleWarehouseRowClick",
    value: function handleWarehouseRowClick(row, column, $event) {
      this.selectWarehouseClick($event, row);

      if (this.helper.isUndefined(this.warehouseTable)) {
        return;
      }

      this.warehouseTable.toggleRowSelection(row);
    }
  }, {
    key: "toggleRowsSelection",
    value: function toggleRowsSelection(rows) {
      var _this12 = this;

      if (this.helper.isUndefined(this.warehouseTable)) {
        return;
      }

      rows ? rows.forEach(function (row) {
        return _this12.warehouseTable.toggleRowSelection(row);
      }) : this.warehouseTable.clearSelection();
    }
  }, {
    key: "hideSendToWarehouseModal",
    value: function () {
      var _hideSendToWarehouseModal = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.isShowSendToWarehouseModal = false;
                this.selectedWarehousePlanId = [];

                if (!this.helper.isUndefined(this.warehouseTable)) {
                  _context10.next = 4;
                  break;
                }

                return _context10.abrupt("return");

              case 4:
                this.warehouseTable.clearSelection();

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function hideSendToWarehouseModal() {
        return _hideSendToWarehouseModal.apply(this, arguments);
      }

      return hideSendToWarehouseModal;
    }()
  }, {
    key: "popUpSendToWarehouseModal",
    value: function () {
      var _popUpSendToWarehouseModal = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.isShowSendToWarehouseModal = true;

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function popUpSendToWarehouseModal() {
        return _popUpSendToWarehouseModal.apply(this, arguments);
      }

      return popUpSendToWarehouseModal;
    }()
  }]);
  return LMDPlanHeaderComponent;
}((0, _vuePropertyDecorator.Mixins)(_loading.LoadingMixin, _lastMileV.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'manual'
})], LMDPlanHeaderComponent.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDPlanHeaderComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$planDate')], LMDPlanHeaderComponent.prototype, "on$PlanDateChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$selectedTruck')], LMDPlanHeaderComponent.prototype, "onSelectedTruckChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isShowSendToWarehouseModal')], LMDPlanHeaderComponent.prototype, "onIsShowSendToWarehouseModalChange", null);
LMDPlanHeaderComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDPlanHeaderComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-input': _elementUi.Input,
    'el-dialog': _elementUi.Dialog,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn
  }
})], LMDPlanHeaderComponent);
var _default = LMDPlanHeaderComponent;
exports.default = _default;